// The Wordy Whiz / Good Distractions mark — a face: a brow bar, two
// lettered lens tiles, and a smile arc. `WW` for Wordy Whiz (the site's
// primary identity — nav, favicon, app icon), `GD` for Good Distractions
// (the company signature — walnut footer only). One mark, two letter
// pairs; geometry is entirely derived from `size` (the lens tile edge,
// in px). Colors are passed in per the brand handoff's fixed
// combinations below — don't invent new ones:
//
//   Context                        lens         lensText     arm
//   On cream (nav, favicon)        --ww-ink     --ww-cream   --ww-rose
//   On walnut (footer, app header) --ww-cream   --ww-ink     --ww-rose
//   App icon, dark (primary)       --ww-cream   --ww-walnut  --ww-rose
//   App icon, light (alternate)    --ww-ink     --ww-cream   --ww-rose
//
// Sizes in use: 19 (web nav), 14 (footer, 52px icon chip), 28 (104px
// app icon). Below size 12 the smile stops resolving — use the two
// lens tiles alone (see the favicon, which drops it entirely).
function Logo({ size = 28, letters = ["W", "W"], lens, lensText, arm }) {
  const gap = Math.max(2, Math.round(size * 0.19));
  const stroke = size >= 24 ? 3 : 2;
  const smile = Math.round(size * 1.3);
  return (
    <span
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: Math.max(2, Math.round(size * 0.15)),
      }}
    >
      <span style={{ width: size * 2 + gap, height: stroke, background: arm, borderRadius: 1 }} />
      <span style={{ display: "flex", gap }}>
        {letters.map((ch, i) => (
          <span
            key={`${ch}-${i}`}
            style={{
              width: size,
              height: size,
              background: lens,
              color: lensText,
              borderRadius: Math.round(size * 0.18),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              font: `600 ${Math.round(size * 0.58)}px var(--ww-font-display)`,
            }}
          >
            {ch}
          </span>
        ))}
      </span>
      <span
        style={{
          width: smile,
          height: Math.round(smile * 0.42),
          borderBottom: `${stroke}px solid ${arm}`,
          borderLeft: `${stroke}px solid transparent`,
          borderRight: `${stroke}px solid transparent`,
          borderRadius: `0 0 ${smile}px ${smile}px`,
        }}
      />
    </span>
  );
}

export default Logo;
